export default function loadScript(src) {
  if (!src) {
    return Promise.reject();
  }
  return new Promise((resolve, reject) => {
    const dom = document.createElement('script');
    dom.onload = () => resolve();
    dom.onerror = reject;
    dom.src = src;
    document.body.appendChild(dom);
  });
}
